"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ga3_service_interface_1 = require("./ga3.service.interface");
const emptyECommerce = {
    ecommerce: null,
};
/**
 * Google Analytics 3 Service for triggering events formatted for GA3
 * configured GTM tags and events.
 *
 * @export
 * @class GA3Service
 */
class GA3Service {
    triggerECommerceEvent(eventType, event) {
        if (this.__hasItems(event)) {
            const pushEvent = {
                ecommerce: null,
                event: eventType,
            };
            switch (eventType) {
                case ga3_service_interface_1.GA3ECommerceEventType.AddPaymentInfo:
                case ga3_service_interface_1.GA3ECommerceEventType.AddShippingInfo:
                case ga3_service_interface_1.GA3ECommerceEventType.AddToWishList:
                case ga3_service_interface_1.GA3ECommerceEventType.AddToCart:
                case ga3_service_interface_1.GA3ECommerceEventType.BeginCheckout:
                case ga3_service_interface_1.GA3ECommerceEventType.Purchase:
                case ga3_service_interface_1.GA3ECommerceEventType.Refund:
                case ga3_service_interface_1.GA3ECommerceEventType.RemoveFromCart:
                case ga3_service_interface_1.GA3ECommerceEventType.ViewCart:
                    pushEvent.ecommerce = this.__cleanMultiItemEvent(event);
                    break;
                case ga3_service_interface_1.GA3ECommerceEventType.SelectItem:
                case ga3_service_interface_1.GA3ECommerceEventType.ViewItemList:
                    pushEvent.ecommerce = this.__cleanListEvent(event);
                    break;
                case ga3_service_interface_1.GA3ECommerceEventType.ViewItem:
                    pushEvent.ecommerce = this.__cleanSingleItemEvent(event);
                    break;
                case ga3_service_interface_1.GA3ECommerceEventType.ViewPromotion:
                case ga3_service_interface_1.GA3ECommerceEventType.SelectPromotion:
                default:
                    pushEvent.ecommerce = event;
                    break;
            }
            this.__push(pushEvent);
        }
    }
    __cleanListEvent(event) {
        var _a, _b;
        const cleanEvent = event;
        (_a = cleanEvent.listId) !== null && _a !== void 0 ? _a : (cleanEvent.listId = window.location.pathname
            .replace(/^\/|\/$/g, '')
            .replace('/', '_'));
        if (cleanEvent.listId) {
            (_b = cleanEvent.listName) !== null && _b !== void 0 ? _b : (cleanEvent.listName = cleanEvent.listId
                .replace(/[_-]/g, ' ')
                .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase()));
        }
        return cleanEvent;
    }
    __cleanMultiItemEvent(event) {
        var _a, _b;
        const cleanEvent = event;
        if (!cleanEvent.items || !cleanEvent.items.length) {
            return cleanEvent;
        }
        (_a = cleanEvent.currency) !== null && _a !== void 0 ? _a : (cleanEvent.currency = cleanEvent.items[0].currency);
        (_b = cleanEvent.value) !== null && _b !== void 0 ? _b : (cleanEvent.value = cleanEvent.items.reduce(function (total, item) {
            var _a, _b;
            return total + (((_a = item.price) !== null && _a !== void 0 ? _a : 0.0) - ((_b = item.discount) !== null && _b !== void 0 ? _b : 0.0));
        }, 0));
        return cleanEvent;
    }
    __cleanSingleItemEvent(event) {
        var _a, _b, _c, _d;
        const cleanEvent = event;
        if (!cleanEvent.items || !cleanEvent.items.length) {
            return cleanEvent;
        }
        cleanEvent.items =
            cleanEvent.items.length == 1
                ? cleanEvent.items
                : cleanEvent.items.slice(0, 1);
        (_a = cleanEvent.currency) !== null && _a !== void 0 ? _a : (cleanEvent.currency = cleanEvent.items[0].currency);
        (_b = cleanEvent.value) !== null && _b !== void 0 ? _b : (cleanEvent.value = ((_c = cleanEvent.items[0].price) !== null && _c !== void 0 ? _c : 0.0) -
            ((_d = cleanEvent.items[0].discount) !== null && _d !== void 0 ? _d : 0.0));
        return cleanEvent;
    }
    __isECommerce(pushEvent) {
        return pushEvent.ecommerce !== undefined;
    }
    __hasItems(event) {
        return event.items && event.items.length > 0;
    }
    __push(pushEvent) {
        if (this.__isECommerce(pushEvent)) {
            window.dataLayer.push(emptyECommerce);
        }
        window.dataLayer.push(pushEvent);
    }
}
exports.default = GA3Service;
//# sourceMappingURL=ga3.service.js.map